
// Metadata for the armpit pain and lymph nodes article
export const armpitPainLymphNodesMetadata = {
  id: "armpit-pain-lymph-nodes",
  slug: "armpit-pain-lymph-nodes-swelling-causes",
  title: "Swollen Lymph Nodes in Armpits: Common Causes and When to Seek Help",
  excerpt: "Learn about the common causes of armpit pain associated with lymph node swelling, what symptoms warrant medical attention, and treatment options.",
  publishedAt: "May 5, 2023",
  readTime: "8 min read",
  category: "Health",
  image: "/lovable-uploads/4dbcd6f6-496c-44e9-be3b-88ef1ea20a41.png",
  metaDescription: "Understand the causes of painful or swollen lymph nodes in the armpit, from infections to more serious conditions, and learn when to seek medical attention.",
  keywords: ["swollen lymph nodes", "armpit lymph nodes", "axillary lymphadenopathy", "armpit lumps", "armpit pain", "lymph node causes", "swollen glands", "natural ways to reduce body odor", "deodorant for excessive sweating", "alcohol-free deodorant for sensitive skin"],
};
